export default __webpack_public_path__ + "static/media/Twitter.7355827a.svg";